"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroResultsMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const ZeroResultsMessage = ({ message, link, linkKeyword }) => {
    const msg = React.useMemo(() => message || '', [message]);
    const index = React.useMemo(() => msg.indexOf(`${linkKeyword}`), [linkKeyword, msg]);
    const { beforeLink, afterLink } = React.useMemo(() => {
        let beforeLinkValue = msg;
        let afterLinkValue = '';
        if (linkKeyword && index !== -1) {
            beforeLinkValue = msg.substr(0, index) || '';
            afterLinkValue = msg.substr(index + `${linkKeyword}`.length) || '';
        }
        return {
            beforeLink: beforeLinkValue,
            afterLink: afterLinkValue,
        };
    }, [index, linkKeyword, msg]);
    const urlLink = React.useMemo(() => {
        if (index !== -1) {
            return (0, jsx_runtime_1.jsx)("a", { href: link && link.url, children: link && link.caption });
        }
        return null;
    }, [index, link]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "coming-soon", children: (0, jsx_runtime_1.jsxs)("p", { children: [(0, jsx_runtime_1.jsx)("span", { children: beforeLink }), urlLink, (0, jsx_runtime_1.jsx)("span", { children: afterLink })] }) }));
};
exports.ZeroResultsMessage = ZeroResultsMessage;
